import React, { useState, useEffect } from "react";
import { ApiWrapped } from "./ApiWrapped";
import { Button, Dialog, Classes, Label } from "@blueprintjs/core";
import api from "../../common/lib/api";
import RestrictionSwitch from "./RestrictionSwitch";

export default function LocationUsers({ token, device }) {
  return (
    <ApiWrapped
      token={token}
      endpoint={`/devices/${device.deviceUuid}/users`}
      renderCallback={function ({ state }) {
        return (
          <table className="bp3-html-table bp3-html-table-striped">
            <tbody>
              {state.data.map((user) => {
                const { firstName, lastName, isAdmin } = user;
                return (
                  <tr key={user.userUuid}>
                    <td>{`${firstName} ${lastName}`}</td>
                    <td>{isAdmin && "Admin"}</td>
                    <td>
                      <UserDetails token={token} device={device} user={user} />
                      <MakeAdmin token={token} device={device} user={user} />
                      <DeleteUser token={token} device={device} user={user} />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        );
      }}
    />
  );
}

function UserDetails({ token, device, user }) {
  const [show, setShow] = useState(false);
  const [state, setState] = useState({
    state: "init",
  });

  useEffect(() => {
    if (show) {
      (async function () {
        try {
          const { data } = await api.get(
            `/devices/${device.deviceUuid}/users/${user.userUuid}`
          );
          const derived = {
            notification: data.notification,
            viewEventHistory: data.viewEventHistory,
            deviceNodes: {},
          };
          for (const node of data.deviceNodes) {
            derived.deviceNodes[node.deviceNodeUuid] = node.permission;
          }
          setState({
            status: "ready",
            data,
            derived,
          });
        } catch (e) {
          alert(e.message);
          setShow(false);
        }
      })();
    }
  }, [device.deviceUuid, show, user.userUuid]);

  if (show && state.status === "ready") {
    const derived = state.derived;
    return (
      <Dialog
        isOpen
        title={`${user.firstName} ${user.lastName}`}
        onClose={() => setShow(false)}
      >
        <div className={Classes.DIALOG_BODY}>
          <p>Name: {`${state.data.firstName} ${state.data.lastName}`}</p>
          <Label>
            General
            <RestrictionSwitch
              label="Can get notifications"
              value={derived.notification}
              onChange={(newValue) => {
                setState((st) => ({
                  ...st,
                  derived: {
                    ...st.derived,
                    notification: newValue,
                  },
                }));
              }}
            />
            <RestrictionSwitch
              label="Can view event history"
              value={derived.viewEventHistory}
              onChange={(newValue) => {
                setState((st) => ({
                  ...st,
                  derived: {
                    ...st.derived,
                    viewEventHistory: newValue,
                  },
                }));
              }}
            />
          </Label>
          <Label>
            Functions
            {state.data.deviceNodes.map((node) => {
              return (
                <RestrictionSwitch
                  label={node.name}
                  value={derived.deviceNodes[node.deviceNodeUuid]}
                  onChange={(newValue) => {
                    setState((st) => ({
                      ...st,
                      derived: {
                        ...st.derived,
                        deviceNodes: {
                          ...st.derived.deviceNodes,
                          [node.deviceNodeUuid]: newValue,
                        },
                      },
                    }));
                  }}
                />
              );
            })}
          </Label>

          <Button
            onClick={async () => {
              try {
                await api.patch(
                  `/devices/${device.deviceUuid}/users/${user.userUuid}`,
                  {
                    ...state.derived,
                    deviceNodes: Object.entries(state.derived.deviceNodes).map(
                      ([deviceNodeUuid, permission]) => {
                        return {
                          deviceNodeUuid,
                          permission,
                        };
                      }
                    ),
                  }
                );
                alert("successful");
                window.location.reload();
              } catch (e) {
                alert(e.message);
              }
            }}
          >
            Save
          </Button>
        </div>
      </Dialog>
    );
  }
  return (
    <Button loading={show} onClick={() => setShow(true)}>
      More
    </Button>
  );
}

function MakeAdmin({ token, device, user }) {
  const [show, setShow] = useState(false);

  return (
    <Button
      loading={show}
      onClick={async () => {
        setShow(true);
        try {
          await api.post(`/devices/${device.deviceUuid}/users/admin`, {
            userUuid: user.userUuid,
          });
          alert("successful");
          window.location.reload();
        } catch (e) {
          alert(e.message);
        }
        setShow(false);
      }}
    >
      Make Admin
    </Button>
  );
}

function DeleteUser({ token, device, user }) {
  const [show, setShow] = useState(false);

  return (
    <Button
      loading={show}
      onClick={async () => {
        setShow(true);
        try {
          await api.delete(
            `/devices/${device.deviceUuid}/users/${user.userUuid}`
          );
          alert("successful");
          window.location.reload();
        } catch (e) {
          alert(e.message);
        }
        setShow(false);
      }}
    >
      Delete
    </Button>
  );
}
